import type { Row } from "@tanstack/react-table"
import type { ReactElement } from "react"
import { useShallow } from "zustand/shallow"

import { usePriceUomColumn } from "../hooks/usePriceUomColumn"

import { PriceUomDisplay } from "@/components/PriceUomDisplay/PriceUomDisplay"
import type { OrderLine, UnitOfMeasurement } from "@/graphql/codegen/graphql"
import { usePurchaseOrderReadonly } from "@/screens/Procurement/PurchaseOrder/hooks/usePurchaseOrderReadonly"
import { useUnitOfMeasurementsStore } from "@/stores/unitOfMeasurmentsStore"

export const PriceUomColumn = ({
  row,
  onOpenPriceDialog,
}: {
  row: Row<OrderLine>
  onOpenPriceDialog?: (rowContent: Row<OrderLine>, pricingUom: UnitOfMeasurement) => void
}): ReactElement => {
  const { convertedPrice, price, total, fetching, isManualPriceSet, purchasingCost } = usePriceUomColumn({
    row,
  })
  const { isReadonly } = usePurchaseOrderReadonly()

  const units = useUnitOfMeasurementsStore(useShallow((s) => s.units))

  const priceUom = units.find((unit) => unit.id === price?.uomId)

  const convertedPriceUom = units.find((unit) => unit.id === convertedPrice?.uomId)

  const hasPriceTier = !isManualPriceSet && purchasingCost && price

  return (
    <PriceUomDisplay
      className='h-24 content-center'
      price={price?.amount ?? null}
      priceUomLabel={priceUom?.name}
      convertedPrice={convertedPrice?.amount}
      convertedPriceUomLabel={convertedPriceUom?.name}
      total={total}
      isFetching={fetching}
      isManualPriceSet={isManualPriceSet}
      effectiveDate={hasPriceTier ? purchasingCost.effectiveDate : undefined}
      disabled={isReadonly}
      onEdit={onOpenPriceDialog ? () => onOpenPriceDialog(row, priceUom!) : undefined}
    />
  )
}
